import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CourseManagementComponent } from "./components/search/course-management.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CourseManagementAddComponent } from "./components/add/course-management-add.component";
import { CourseManagementEditComponent } from "./components/edit/course-management-edit.component";
import { CourseManagementSearchFormComponent } from "./components/search/form/course-management-search-form.component";
import { CourseManagementSearchResultsComponent } from "./components/search/results/course-management-search-results.component";
import { UIComponentsModule } from "@tva/ng-migration/uicomponents/uicomponents.module";
import { CourseManagementServiceProvider } from "./services/course-management/courseManagementService.provider";
import { SharedModule } from "@tva/ng-migration/shared/shared.module";
import "./course-management.config";
import "./course-management.downgrades";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
  declarations: [
    CourseManagementComponent,
    CourseManagementSearchFormComponent,
    CourseManagementSearchResultsComponent,
    CourseManagementAddComponent,
    CourseManagementEditComponent,
  ],
  providers: [CourseManagementServiceProvider],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, UIComponentsModule, SharedModule, MatButtonModule, MatDialogModule],
})
export class CourseManagementModule { }
